const $ = require('jquery');

if ($.isFunction($.fn.slick)) {

    $('.cards__slider').slick({
        rows: 0,
        arrows: true,
        prevArrow: '<button class="slick-control slick-control--previous" data-gtm-event="Cards slider control: previous"><span class="slick-control__inner"><i class="fal fa-angle-left"></i></span></button>',
        nextArrow: '<button class="slick-control slick-control--next" data-gtm-event="Cards slider control: next"><span class="slick-control__inner"><i class="fal fa-angle-right"></i></span></button>',
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 500,
        infinite: false,
        swipeToSlide: true,
        lazyLoad: 'ondemand',
        customPaging: function (slick, index) {
            return '<button type="button" id="slick-dot-' + index + '" class="slick-dot" rel="nofollow"></button>';
        },
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 580,
            settings: {
                slidesToShow: 1,
                adaptiveHeight: true
            }
        }]
    });

    $('.cards__slider.cards__slider--four-columns').slick('slickSetOption', {
        slidesToShow: 4,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 3
            }
        },{
            breakpoint: 991,
            settings: {
                slidesToShow: 2
            }
        },{
            breakpoint: 580,
            settings: {
                slidesToShow: 1,
                adaptiveHeight: true
            }
        }]
    }, true);

    $('.logos__slider').slick({
        rows: 0,
        arrows: true,
        prevArrow: '<button class="slick-control slick-control--previous" data-gtm-event="Logos slider control: previous"><span class="slick-control__inner"><i class="fal fa-angle-left"></i></span></button>',
        nextArrow: '<button class="slick-control slick-control--next" data-gtm-event="Logos slider control: next"><span class="slick-control__inner"><i class="fal fa-angle-right"></i></span></button>',
        dots: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        swipeToSlide: true,
        infinite: true,
        speed: 250,
        lazyLoad: 'ondemand',
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 5
            }
        },{
            breakpoint: 991,
            settings: {
                slidesToShow: 4
            }
        },{
            breakpoint: 767,
            settings: {
                slidesToShow: 3
            }
        },{
            breakpoint: 580,
            settings: {
                slidesToShow: 2
            }
        }]
    });

    $('.cases-large__slider, .employees-large__slider').each(function() {
        let $slider = $(this),
            sliderClass = $(this).attr('class');

        $slider.slick({
            rows: 0,
            arrows: true,
            prevArrow: '<button class="slick-control slick-control--previous" data-gtm-event="'+ sliderClass +' control: previous"><span class="slick-control__inner"><i class="fal fa-angle-left"></i></span></button>',
            nextArrow: '<button class="slick-control slick-control--next" data-gtm-event="'+ sliderClass +' control: next"><span class="slick-control__inner"><i class="fal fa-angle-right"></i></span></button>',
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true,
            infinite: true,
            speed: 1000,
            lazyLoad: 'ondemand',
            adaptiveHeight: true
        });
    })

    // moving sliders when item that is not active is clicked
    $('.cards__slider, .cases-large__slider').on( 'click', '.slick-slide', function(e) {
        let $slider = $(this).closest('.slick-slider');

        if( !$(this).hasClass('slick-active') ) {
            e.preventDefault();

            // check if slide is before or after active slides
            if( $(this).prevAll('.slick-active').length ) {
                // console.log('element comes after active');
                $slider.slick('slickNext');
            } else {
                // console.log('element comes before active');
                $slider.slick('slickPrev');
            }
        }
    });

    $('.booking__steps').each(function () {
        let $slider = $(this),
            $wrapper = $(this).closest('.booking'),
            $loader = $wrapper.find('.booking__loader'),
            classLoaderVisible = 'booking__loader--visible',
            $progressStep = $wrapper.find('.booking__progress-step'),
            $progressFill = $wrapper.find('.booking__progress-fill'),
            classStepActive = 'booking__progress-step--active',
            classStepCompleted = 'booking__progress-step--completed',
            scrollOffset = $('header.masthead').outerHeight() + 16;

        $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {

            $loader.addClass(classLoaderVisible);

            // scroll back to top
            $('html, body').animate({
                scrollTop: $wrapper.stop().offset().top - scrollOffset
            }, 500);

            let totalSlides = $slider.find('.slick-slide').length,
                percentageCompleted = 100 / (totalSlides - 2) * nextSlide, // totalslides - 2 because last slide is a confirmation and not a "real" step
                $nextStep = $progressStep.eq(nextSlide);

            // update progress-bar step status (active, completed)
            if (nextSlide+1 === totalSlides) {
                // on last confirmation step
                $progressFill.addClass('booking__progress-fill--full');
                $progressStep.removeClass(classStepActive).addClass(classStepCompleted);
            } else {
                $nextStep.prevAll().addClass(classStepCompleted);
                $nextStep.siblings().removeClass(classStepActive);
                $nextStep.removeClass(classStepCompleted).addClass(classStepActive);
            }

            if (percentageCompleted > 100) percentageCompleted = 100;

            // update progress-bar progress fill
            $progressFill.css('width', percentageCompleted + '%');

        }).on('afterChange', function () {

            setTimeout(function () {
                $loader.removeClass(classLoaderVisible);
            }, 300);

        }).slick({
            rows: 0,
            arrows: false,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            fade: true,
            infinite: false,
            adaptiveHeight: true,
            accessibility: false,
            draggable: false,
            swipe: false,
            swipeToSlide: false,
            touchMove: false,
        });

        $slider.on('refresh-slider', function () {
            $slider.slick('setPosition');
        });

        $slider.find('.btn--booking-next').on('click', function () {
            $slider.slick('slickNext');
        });

        $slider.find('.btn--booking-prev').on('click', function () {
            $slider.slick('slickPrev');
        });
    });

} else {
    console.log('.slick() is not a function');
}